import { Injectable, inject } from '@angular/core';
import { combineLatest, map, shareReplay } from 'rxjs';
import { Plugin } from '@jeppesen-foreflight/jmkw-types';
import { AirmetsPluginService } from './airmets/airmets.plugin.service';
import { GlobalIRSatelliteCompositePluginService } from './global-ir-satellite-composite/global-ir-satellite-composite.plugin.service';
import { GlobalIRSatelliteRadarPluginService } from './global-ir-satellite-radar/global-ir-satellite-radar.plugin.service';
import { GovernmentSigmetsPluginService } from './government-sigmets/government-sigmets.plugin.service';
import { LightningGeoJsonPluginService } from './lightning-geojson/lightning.plugin.service';
import { MetarsPluginService } from './metars/metars.plugin.service';
import { PirepsPluginService } from './pireps/pireps.plugin.service';
import { PrecipitationPluginService } from './precipitation/precipitation.plugin.service';
import { RadarEchoTopsPluginService } from './radar-echo-tops/radar-echo-tops.plugin.service';
import { SurfaceAnalysisPluginService } from './surface-analysis/surface-analysis.plugin.service';
import { VolcanicPluginService } from './volcanic/volcanic.plugin.service';
import { WaterVaporPluginService } from './water-vapor/water-vapor.plugin.service';
import { WeatherTropicalStormPluginService } from './weather-tropical-storm/weather-tropical-storm.plugin.service';
import { WinterRadarOverlayPluginService } from './winter-radar-overlay/winter-radar-overlay.plugin.service';

@Injectable({
  providedIn: 'root'
})
export class TwcObservationPluginService {
  governmentSigmets$ = inject(GovernmentSigmetsPluginService).plugin$;
  lightningJson$ = inject(LightningGeoJsonPluginService).plugin$;
  pireps$ = inject(PirepsPluginService).plugin$;
  weatherTropicalStorm$ = inject(WeatherTropicalStormPluginService).plugin$;
  waterVapor$ = inject(WaterVaporPluginService).plugin$;
  globalIRSatelliteRadar$ = inject(GlobalIRSatelliteRadarPluginService).plugin$;
  surfaceAnalysis$ = inject(SurfaceAnalysisPluginService).plugin$;
  radarEchoTops$ = inject(RadarEchoTopsPluginService).plugin$;
  volcanic$ = inject(VolcanicPluginService).plugin$;
  metars$ = inject(MetarsPluginService).plugin$;
  precipitation$ = inject(PrecipitationPluginService).plugin$;
  airmets$ = inject(AirmetsPluginService).plugin$;
  winterWinterRadarOverlay$ = inject(WinterRadarOverlayPluginService).plugin$;
  globalIRSatelliteComposite$ = inject(GlobalIRSatelliteCompositePluginService)
    .plugin$;

  plugin$ = combineLatest([
    this.governmentSigmets$,
    this.radarEchoTops$,
    this.surfaceAnalysis$,
    this.globalIRSatelliteRadar$,
    this.lightningJson$,
    this.pireps$,
    this.globalIRSatelliteComposite$,
    this.metars$,
    this.winterWinterRadarOverlay$,
    this.volcanic$,
    this.waterVapor$,
    this.airmets$,
    this.precipitation$,
    this.weatherTropicalStorm$
  ]).pipe(
    map(
      (twcPlugins) =>
        new Plugin({
          id: 'observation',
          children: twcPlugins
        })
    ),
    shareReplay(1)
  );
}
